export default __webpack_public_path__ + "static/media/yantralive-new-banner3.9f1b8cda.png";